/**
* Counter JS
* -----------------------------------------------------------------------------
*
* All the JS for the Counter component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'counter',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.counter' ).not( '.is-animated' ).each( function( key, component ) {
        let isAnimated = false;
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            start: 'top 75%',
            scrub: 0.5,
            onEnter: ( {progress, direction, isActive} ) => {
              if ( !isAnimated ) {
                numberAnimations( component );
                isAnimated = true;
              }
            },
          },
        } );
      } );

      function numberAnimations( el ) {
        $( el ).find( '.stat' ).each( function() {
          const $this = $( this );
          const initialNum = $( this ).text();
          const counter = 0;
          const size = $( this ).text().split( '.' )[1] ? $( this ).text().split( '.' )[1].length : 0;
          $( {Counter: counter} ).animate( {Counter: $this.text().replace( /,/g, '' )}, {
            duration: 1000,
            easing: 'swing',
            step: function() {
              const num = parseFloat( this.Counter ).toFixed( size ).toString().replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
              $this.text( num );
            },
            complete: function() {
              $this.text( initialNum.replace( /\B(?=(\d{3})+(?!\d))/g, ',' ) );
            },
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'counter', COMPONENT );
} )( app );
